/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-12-10 16:33:11
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-12-10 17:18:25
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/style/index.scss";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import SlideVerify from "vue-monoplasty-slide-verify";
// import MetaInfo from "vue-meta-info";

// Vue.use(MetaInfo);
Vue.use(SlideVerify);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    // document.dispatchEvent(new Event("render-event"));
    document.dispatchEvent(new Event("custom-render-trigger"));
  },
}).$mount("#app");
